// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-cc496c1d] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.color-picker[data-v-cc496c1d] {
  display: flex;
  overflow: hidden;
  align-content: flex-end;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: content-box !important;
  width: 176px;
  padding: 8px;
  border-radius: 3px;
}
.color-picker--advanced-fields[data-v-cc496c1d] {
  width: 264px;
}
.color-picker__simple[data-v-cc496c1d] {
  display: grid;
  grid-template-columns: repeat(auto-fit, var(--default-clickable-area));
  grid-auto-rows: var(--default-clickable-area);
}
.color-picker__simple-color-circle[data-v-cc496c1d] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--default-clickable-area) - 10px);
  height: calc(var(--default-clickable-area) - 10px);
  min-height: calc(var(--default-clickable-area) - 10px);
  margin: auto;
  padding: 0;
  color: white;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  font-size: 16px;
}
.color-picker__simple-color-circle[data-v-cc496c1d]:focus-within {
  outline: 2px solid var(--color-main-text);
}
.color-picker__simple-color-circle[data-v-cc496c1d]:hover {
  opacity: 0.6;
}
.color-picker__simple-color-circle--active[data-v-cc496c1d] {
  width: calc(var(--default-clickable-area) - 6px);
  height: calc(var(--default-clickable-area) - 6px);
  min-height: calc(var(--default-clickable-area) - 6px);
  transition: all 100ms ease-in-out;
  opacity: 1 !important;
}
.color-picker__advanced[data-v-cc496c1d] {
  box-shadow: none !important;
}
.color-picker__navigation[data-v-cc496c1d] {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
[data-v-cc496c1d]  .vc-chrome {
  width: unset;
  background-color: var(--color-main-background);
}
[data-v-cc496c1d]  .vc-chrome-color-wrap {
  width: 30px;
  height: 30px;
}
[data-v-cc496c1d]  .vc-chrome-active-color {
  width: calc(var(--default-clickable-area) - 10 px);
  height: calc(var(--default-clickable-area) - 10 px);
  border-radius: 17px;
}
[data-v-cc496c1d]  .vc-chrome-body {
  padding: 14px 0 0 0;
  background-color: var(--color-main-background);
}
[data-v-cc496c1d]  .vc-chrome-body .vc-input__input {
  box-shadow: none;
}
[data-v-cc496c1d]  .vc-chrome-toggle-btn {
  filter: var(--background-invert-if-dark);
}
[data-v-cc496c1d]  .vc-chrome-saturation-wrap {
  border-radius: 3px;
}
[data-v-cc496c1d]  .vc-chrome-saturation-circle {
  width: 20px;
  height: 20px;
}
.slide-enter[data-v-cc496c1d] {
  transform: translateX(-50%);
  opacity: 0;
}
.slide-enter-to[data-v-cc496c1d] {
  transform: translateX(0);
  opacity: 1;
}
.slide-leave[data-v-cc496c1d] {
  transform: translateX(0);
  opacity: 1;
}
.slide-leave-to[data-v-cc496c1d] {
  transform: translateX(-50%);
  opacity: 0;
}
.slide-enter-active[data-v-cc496c1d], .slide-leave-active[data-v-cc496c1d] {
  transition: all 50ms ease-in-out;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcColorPicker-CpkfRGO1.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sEAAsE;EACtE,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,kDAAkD;EAClD,sDAAsD;EACtD,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;AACd;AACA;EACE,gDAAgD;EAChD,iDAAiD;EACjD,qDAAqD;EACrD,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kDAAkD;EAClD,mDAAmD;EACnD,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-cc496c1d] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.color-picker[data-v-cc496c1d] {\n  display: flex;\n  overflow: hidden;\n  align-content: flex-end;\n  flex-direction: column;\n  justify-content: space-between;\n  box-sizing: content-box !important;\n  width: 176px;\n  padding: 8px;\n  border-radius: 3px;\n}\n.color-picker--advanced-fields[data-v-cc496c1d] {\n  width: 264px;\n}\n.color-picker__simple[data-v-cc496c1d] {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, var(--default-clickable-area));\n  grid-auto-rows: var(--default-clickable-area);\n}\n.color-picker__simple-color-circle[data-v-cc496c1d] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(var(--default-clickable-area) - 10px);\n  height: calc(var(--default-clickable-area) - 10px);\n  min-height: calc(var(--default-clickable-area) - 10px);\n  margin: auto;\n  padding: 0;\n  color: white;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-radius: 50%;\n  font-size: 16px;\n}\n.color-picker__simple-color-circle[data-v-cc496c1d]:focus-within {\n  outline: 2px solid var(--color-main-text);\n}\n.color-picker__simple-color-circle[data-v-cc496c1d]:hover {\n  opacity: 0.6;\n}\n.color-picker__simple-color-circle--active[data-v-cc496c1d] {\n  width: calc(var(--default-clickable-area) - 6px);\n  height: calc(var(--default-clickable-area) - 6px);\n  min-height: calc(var(--default-clickable-area) - 6px);\n  transition: all 100ms ease-in-out;\n  opacity: 1 !important;\n}\n.color-picker__advanced[data-v-cc496c1d] {\n  box-shadow: none !important;\n}\n.color-picker__navigation[data-v-cc496c1d] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n[data-v-cc496c1d]  .vc-chrome {\n  width: unset;\n  background-color: var(--color-main-background);\n}\n[data-v-cc496c1d]  .vc-chrome-color-wrap {\n  width: 30px;\n  height: 30px;\n}\n[data-v-cc496c1d]  .vc-chrome-active-color {\n  width: calc(var(--default-clickable-area) - 10 px);\n  height: calc(var(--default-clickable-area) - 10 px);\n  border-radius: 17px;\n}\n[data-v-cc496c1d]  .vc-chrome-body {\n  padding: 14px 0 0 0;\n  background-color: var(--color-main-background);\n}\n[data-v-cc496c1d]  .vc-chrome-body .vc-input__input {\n  box-shadow: none;\n}\n[data-v-cc496c1d]  .vc-chrome-toggle-btn {\n  filter: var(--background-invert-if-dark);\n}\n[data-v-cc496c1d]  .vc-chrome-saturation-wrap {\n  border-radius: 3px;\n}\n[data-v-cc496c1d]  .vc-chrome-saturation-circle {\n  width: 20px;\n  height: 20px;\n}\n.slide-enter[data-v-cc496c1d] {\n  transform: translateX(-50%);\n  opacity: 0;\n}\n.slide-enter-to[data-v-cc496c1d] {\n  transform: translateX(0);\n  opacity: 1;\n}\n.slide-leave[data-v-cc496c1d] {\n  transform: translateX(0);\n  opacity: 1;\n}\n.slide-leave-to[data-v-cc496c1d] {\n  transform: translateX(-50%);\n  opacity: 0;\n}\n.slide-enter-active[data-v-cc496c1d], .slide-leave-active[data-v-cc496c1d] {\n  transition: all 50ms ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
